import React, {useMemo} from "react";
import {Link, useNavigate} from 'react-router-dom';
import InfoTooltip from "../../../components/InfoTooltip";
import CircleProgress, { SimpleCircleProgress } from "../../../components/CircleProgress";
import SupplierOppInfoSection from "./SupplierOppInfoSection";

const MAX_TALENT_MATCH = 2;

const SupplierJobBoardCard = ({ job, onStore, isDisabled }) => {

    const description = useMemo(() => {
        let html = job.description || job.project?.description || '<p><i>No Description</i></p>';
        return html.replace(/<[^/>][^>]*><\/[^>]+>/gim,'')
    }, [job])
    const navigate = useNavigate();

    return (
        <div className="supplier-job-board-card bg-white py-8 px-6 flex flex-col gap-2">
            <div className="flex flex-grow flex-row justify-between gap-3">
                <div className="flex flex-row items-start gap-2">
                    <div className="min-h-24 min-w-24 h-24 w-24 flex items-stretch justify-center rounded-full border border-solid border-wripplePrimaryRuleBlue">
                        <img src={job.client.logo_path} alt="" className="object-contain" />
                    </div>

                    <div className="flex flex-col justify-start">
                        <p className="text-wripplePrimaryDarkNavy text-xs mb-1.5 italic font-light">Posted {TB.moment(job.posted_at).fromNow()}</p>
                        <p className="job-position-name">
                            {job.title}
                        </p>
                        <p className="text-sm mb-2.5">
                            {job.client?.name}
                        </p>
                    </div>
                </div>
                <SupplierOppInfoSection job={job} />
            </div>

            <div className="flex flex-row items-stretch gap-5 mt-3 divide-x divide-wrippleLightGrayBg">
                <div className="w-[65%] flex flex-col items-stretch gap-2">
                    <div className="job-short-description"
                         dangerouslySetInnerHTML={{
                             __html: description
                         }}/>
                    <div>

                    </div>
                    <div className="self-stretch px-3 flex items-center flex-row justify-between gap-4">
                        <p className="text-xs">
                            <span className="text-wripplePrimaryDarkNavy font-semibold">Wripple {TB.pluralize('Role', job.disciplines?.length)}:</span>
                            &nbsp;{TB.map(job.disciplines || [], (dis, i) => (
                                <React.Fragment key={`${dis.name}-${job.id}`}>
                                    <span className="text-primary font-semibold">
                                        {dis.name}
                                    </span>
                                    {i < job.disciplines?.length - 1 && ', '}
                                </React.Fragment>
                            ))}
                        </p>
                        <div className="gap-4 flex flex-row items-center ml-auto">
                            {job?.related_agency_opportunity_id ? (
                                <button className="pointer-events-none btn btn-success min-w-[120px] whitespace-nowrap">
                                    <i className="fas fa-check mr-2"/> Brief Accepted
                                </button>
                            ) : (
                                <button disabled={isDisabled || !job.matching_talent_count} onClick={onStore} className="btn btn-primary min-w-[120px] whitespace-nowrap">
                                    Accept Brief
                                </button>
                            )}

                            <Link to={`job-details/${job.id}`} disabled={isDisabled} className="btn btn-dark min-w-[120px] whitespace-nowrap">
                                View Job Posting
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="w-[25%] flex-grow ml-auto flex flex-col items-stretch px-4">

                    {!job.matching_talent_count && (
                        <p className="text-wripplePrimaryDarkNavy text-center">No Employee Matches</p>
                    )}

                    {!!job.matching_talent_count && (
                        <>
                            <div className="flex">
                                <div className="basis-3/5">
                                    <p className="text-wripplePrimaryDarkNavy text-xs">Employee Match</p>
                                </div>
                                <div className="basis-2/5">
                                    <p className="text-wripplePrimaryDarkNavy text-xs">Match Score</p>
                                </div>
                                {/*<div className="flex-1">*/}
                                {/*    <p className="text-wripplePrimaryDarkNavy text-xs">*/}
                                {/*        Action*/}
                                {/*    </p>*/}
                                {/*</div>*/}
                            </div>

                            {TB.take(TB.orderBy(job.matching_talent, 'matching.overall.percent', 'desc'), MAX_TALENT_MATCH).map(talent => {
                                return (
                                    <div key={talent.id} className="flex py-2">
                                        <div className="basis-3/5">
                                            <div className="flex">
                                                <img src={talent.image_path} alt="" className="h-6 w-6 mr-2 rounded-full object-cover" />
                                                <p>{talent.first_name} {talent.last_name}</p>
                                            </div>
                                        </div>

                                        <div className="basis-2/5">
                                            <div className="flex items-center" id={`jobboard-match-${job.id}-talent-${talent.id}`}>
                                                <SimpleCircleProgress
                                                    stroke={18}
                                                    className="mr-2"
                                                    value={talent.matching.overall.percent}
                                                />
                                                <p className="whitespace-no-wrap">{Math.round(talent.matching.overall.percent)}% match</p>

                                            </div>

                                            <InfoTooltip
                                                type="bggray"
                                                placement="bottom"
                                                target={`jobboard-match-${job.id}-talent-${talent.id}`}
                                                tooltipProps={{
                                                    style: { maxWidth: 'unset' }
                                                }}
                                            >
                                                <div className="p-2 flex items-center gap-4">
                                                    <div className="flex-1 flex flex-col justify-center ">
                                                        <p className="p-0 pb-2 font-semibold text-wrippleBlueGray">Skills <br /> Expertise</p>

                                                        <CircleProgress
                                                            progress={talent.matching.skills.overall.percent}
                                                            strokeWidth={8}
                                                            size={85}
                                                        >
                                                            <p className="text-wrippleBlueGray">
                                                                <span className="text-sm">{talent.matching.skills.overall.percent}%</span>
                                                                <small className="text-xxs">Match</small>
                                                            </p>
                                                        </CircleProgress>
                                                    </div>

                                                    <div className="flex-1 flex flex-col justify-center ">
                                                        <p className="p-0 pb-2 font-semibold text-wrippleBlueGray">Years <br /> Experience</p>

                                                        <CircleProgress
                                                            progress={talent.matching.experience.percent}
                                                            strokeWidth={8}
                                                            size={85}
                                                            style={{ margin: '0 auto' }}
                                                        >
                                                            <p className="text-wrippleBlueGray">
                                                                <span className="text-sm">{talent.matching.experience.percent}%</span>
                                                                <small className="text-xxs">Match</small>
                                                            </p>
                                                        </CircleProgress>
                                                    </div>


                                                    <div className="flex-1 flex flex-col justify-center ">
                                                        <p className="p-0 pb-2 font-semibold text-wrippleBlueGray">Industry <br /> Experience</p>

                                                        <CircleProgress
                                                            progress={talent.matching.industries.overall.percent}
                                                            strokeWidth={8}
                                                            size={85}
                                                        >
                                                            <p className="text-wrippleBlueGray">
                                                                <span className="text-sm">{talent.matching.industries.overall.percent}%</span>
                                                                <small className="text-xxs">Match</small>
                                                            </p>
                                                        </CircleProgress>
                                                    </div>


                                                </div>
                                            </InfoTooltip>
                                        </div>

                                        {/*<div className="flex-1">*/}
                                        {/*    <button className="btn-success btn-sm btn px-2 py-1.5 text-xs text-white">*/}
                                        {/*        Show Interest*/}
                                        {/*    </button>*/}
                                        {/*</div>*/}
                                    </div>

                                )
                            })}

                            {job.matching_talent_count > MAX_TALENT_MATCH && (
                                <div className="flex">
                                    <p className="flex-1 text-center text-xs text-info">
                                        + {job.matching_talent_count - MAX_TALENT_MATCH} more
                                    </p>
                                </div>
                            )}
                        </>
                    )}
                </div>


            </div>

            {/*<div className="px-4">*/}
            {/*    <button*/}
            {/*        className="btn btn-primary self-center whitespace-nowrap"*/}
            {/*        type="button"*/}
            {/*        onClick={() => console.log('Review Brief')}*/}
            {/*    >*/}
            {/*        Review Brief*/}
            {/*    </button>*/}
            {/*</div>*/}


        </div>
    )
}

export default SupplierJobBoardCard;